import {} from "../baseStyles.jsx";

const eventsFilterStyle = () => ({});
export default eventsFilterStyle;
